// extracted by mini-css-extract-plugin
export default {"left-extras":"Technologies_left-extras__5zrNJ","right-extras":"Technologies_right-extras__lQdXt","technologies":"Technologies_technologies__KMRSM"};